import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import Loading from "../../../../../Common/Components/Loading";
import {
  CostRender,
  addDate,
  ToDateJalali,
  ConvertDate,
  Day,
  dateInputYMD,
  scrollToTop,
  GenderRender,
} from "../../../../../Common/Function/index";
import { useSelector } from "react-redux";
import { useTableWeek } from "./Hooks";
import moment from "jalali-moment";
import CustomModal from "../../../../../Common/Components/Modal/CustomModal";
import DatePicker, {
  Calendar,
  getAllDatesInRange,
} from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Spinner } from "react-bootstrap";

function Index() {
  const {
    loadingWeek,
    week,
    getWeek,
    days,
    convertDay,
    statusHandler,
    getDate,
    changeStatus,
    loadingSans,
    checkCurrentWeek,
    getYear,
    modal,
    setModal,
    reserveByManager,
    cancelByManager,
    updateTimeTable,
    loadingBtn,
    showReserve,
    list,
    setList,
    loading,
  } = useTableWeek();
  useEffect(() => {
    getWeek();
  }, []);

  return (
    <div>
      <div className="col-12">
        <div className="row">
          <div className="col">
            <h5 className="text-center">زمان بندی مجموعه شما</h5>
          </div>
        </div>
        <div className="card shadow-sm">
          <div
            style={{
              backgroundColor: "#fafafa",
              borderBottomStyle: "dashed",
              borderBlockColor: "rgb(221, 221, 221)",
            }}
          >
            <div className="row justify-content-between py-3" style={{}}>
              <div className="col-2 d-flex  align-items-center justify-content-center ">
                <div className="d-flex align-items-center justify-content-center">
                  <h6
                    style={{
                      cursor: "pointer",
                    }}
                    className="text-center m-0  d-flex align-items-center last-date"
                    onClick={() => {
                      getWeek({
                        date: !loadingWeek && week.key.lastweek,
                      });
                    }}
                  >
                    {" "}
                    {!loadingWeek && week.key.lastweek && (
                      <>
                        <i className="fas fa-angle-right mx-2" /> {" هفته قبل"}
                      </>
                    )}
                  </h6>
                </div>
              </div>
              <div className="col-8 d-flex  align-items-center justify-content-center">
                <div
                  className="d-flex align-items-center justify-content-center "
                  style={{
                    flexDirection: "column",
                  }}
                >
                  <p>
                    <span>سال {getYear(days && days[5], week)}</span>
                  </p>
                  <p
                    onClick={() => {
                      getWeek({});
                    }}
                    className="text-center"
                    style={{
                      color: "#aaa",
                      cursor: "pointer",
                    }}
                  >
                    {!loadingWeek &&
                      checkCurrentWeek(week) &&
                      ` امروز : ${moment().locale("fa").format("YYYY/MM/DD")}`}
                    {!loadingWeek && !checkCurrentWeek(week) && "برو به امروز"}
                  </p>
                </div>
              </div>
              <div className="col-2 d-flex  align-items-center justify-content-center">
                <div className="d-flex align-items-center justify-content-center">
                  <h6
                    style={{
                      cursor: "pointer",
                    }}
                    className="text-center m-0 d-flex align-items-center last-date"
                    onClick={() => {
                      getWeek({
                        date: !loadingWeek && week.key.nextweek,
                      });
                    }}
                  >
                    {!loadingWeek && week.key.nextweek && (
                      <>
                        {" هفته بعد"}
                        <i className="fas fa-angle-left mx-2"></i>
                      </>
                    )}
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              {loadingWeek ? (
                <Loading count={1} col={12} height={250} />
              ) : (
                <>
                  <div className="table-responsive ">
                    <table
                      className="table w-100"
                      style={{
                        borderCollapse: "collapse",
                        overflow: "hidden",
                      }}
                    >
                      <thead
                        style={{
                          border: "none",
                          borderBottomStyle: "dashed",
                          borderBottomWidth: "1.6px",
                          borderBottomColor: "#ddd",
                        }}
                      >
                        <tr>
                          <th scope="col"></th>
                          {!loadingWeek &&
                            days.map((day, key) => (
                              <th
                                key={key}
                                style={{
                                  backgroundColor: "#fff",
                                  borderBottomStyle: "dashed",
                                }}
                              >
                                <div className="d-flex flex-column day-table">
                                  <span
                                    style={{ color: "#444" }}
                                    className="text-center"
                                  >
                                    {convertDay(day)}
                                  </span>
                                  <span
                                    style={{
                                      color: "#999",
                                      fontSize: "12px",
                                    }}
                                    className="text-center"
                                  >
                                    {getDate(day, week)}
                                  </span>
                                </div>
                              </th>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {!loadingWeek &&
                          week.template.map((temp, count) => (
                            <tr key={count}>
                              <th
                                style={{
                                  padding: "0px",
                                }}
                                scope="row"
                                className="text-center"
                              >
                                <h6
                                  className="time-table-span"
                                  style={{
                                    marginTop: "10px",
                                  }}
                                >
                                  {window.screen.width > 700
                                    ? `${temp.time.split("-")[0]} تا ${
                                        temp.time.split("-")[1]
                                      }`
                                    : temp.time.split("-")[0]}
                                </h6>
                              </th>
                              {days.map((day, key) => (
                                <Sans
                                  data={week.data[day].times[count]}
                                  day={getDate(day, week, true)}
                                  set={changeStatus}
                                  currentDay={day}
                                  key={key}
                                />
                              ))}
                            </tr>
                          ))}
                      </tbody>
                      <CustomModal
                        handleClose={() => {
                          setModal(false);
                          getWeek();
                        }}
                        header={"ویرایش سانس"}
                        show={modal}
                      >
                        <Guid data={modal} />
                      </CustomModal>
                    </table>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const Guid = ({ data }) => {
  const [step, setStep] = useState("select");
  const { user } = useSelector(state => state);
  const {
    updateTimeTable,
    loadingBtn,
    reserveByManager,
    statusHandler,
    cancelByManager,
  } = useTableWeek();
  const [state, setState] = useState({
    once: true,
  });
  const [contract, setContract] = useState({
    contract_type: "onceaweek",
  });
  const renderSteps = () => {
    if (statusHandler(data && data.data)["status"] == "reserve") {
      return <ShowReserve data={data} />;
    } else if (data.status == "cancel") {
      return (
        <div>
          <div className="row justify-content-end">
            <div className="col-2">
              <button className="btn" onClick={() => setStep("select")}>
                <span>بازگشت</span>
                <i className="fas fa-angle-left mx-2"></i>
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex flex-column justify-content-between align-items-md-stretch">
                <div>
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault2"
                  >
                    {`کنسل کردن سانس :‌ ${data && data.data.time} `}
                    {` در تاریخ : ${ToDateJalali(data && data.day)}`}
                  </label>
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="row mt-3">
            <div className="col">
              <div>
                <button
                  className="btn btn-primary"
                  disabled={loadingBtn}
                  onClick={() => {
                    cancelByManager({
                      once_reserve: true,
                      sans_id: data.data.id,
                      day: data.data.day_id,
                    });
                  }}
                >
                  {loadingBtn ? "در حال پردازش" : "کنسل کردن رزرو"}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (statusHandler(data && data.data)["status"] == "another") {
      return (
        <div>
          <p>این سانس در حال رزرو توسط کاربری می باشد</p>
        </div>
      );
    } else {
      switch (step) {
        case 1:
          return (
            <div>
              <div className="row justify-content-end">
                <div className="col-2">
                  <button className="btn" onClick={() => setStep("select")}>
                    <span>بازگشت</span>
                    <i className="fas fa-angle-left mx-2"></i>
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <label htmlFor="price">قیمت اصلی</label>
                  <input
                    onChange={e =>
                      setState({ ...state, price: e.target.value })
                    }
                    type="text"
                    className="form-control"
                    placeholder="قیمت"
                    defaultValue={data && data.data.price}
                    id="price"
                  />
                </div>
                <div className="col-6">
                  <label htmlFor="second_price">قیمت دوم</label>
                  <input
                    autoComplete={"off"}
                    onChange={e =>
                      setState({ ...state, second_price: e.target.value })
                    }
                    type="text"
                    className="form-control"
                    placeholder="قیمت دوم"
                    defaultValue={data && data.data.second_price}
                    id="second_price"
                  />
                </div>

                <div className="col-6">
                  <label htmlFor="second_price">جنسیت</label>
                  <select
                    name=""
                    id=""
                    className="form-control"
                    onChange={e => {
                      setState({
                        ...state,
                        gender: e.target.value,
                      });
                    }}
                  >
                    {[
                      { name: "آقایان", key: "men" },
                      { name: "بانوان", key: "women" },
                    ].map((opt, count) => {
                      return (
                        <option
                          key={count}
                          value={opt.key}
                          selected={opt.key == data.data.gender}
                        >
                          {opt.name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="col-12 elements_sans" id="start">
                  <label>پایان اعتبار قیمت دوم</label>
                  <Calendar
                    // range={true}
                    onChange={data => {
                      setState({
                        ...state,
                        second_exp: ConvertDate(
                          `${data.year}/${data.month.number}/${data.day}`
                        ),
                      });
                    }}
                    calendar={persian}
                    // multiple={true}
                    locale={persian_fa}
                  />
                </div>
              </div>
              <div>
                <div className="form-check mt-2">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                    defaultChecked
                    onClick={() => setState({ ...state, once: true })}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault1"
                  >
                    ویرایش سانس در همین روز
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault2"
                    onClick={() => {
                      let newState = { ...state };
                      delete newState["once"];
                      setState({
                        ...newState,
                        day: data.data.day_id,
                      });
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault2"
                  >
                    ویرایش سانس در تمامی روز ها
                  </label>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <button
                    disabled={loadingBtn}
                    className="btn btn-primary text-white my-2"
                    onClick={() =>
                      updateTimeTable({
                        ...state,
                        sans_id: data.data.id,
                        day: data.data.day_id,
                      })
                    }
                  >
                    {loadingBtn ? "در حال پردازش" : "ثبت اطلاعات"}
                  </button>
                </div>
              </div>
            </div>
          );
        case 2:
          return (
            <div>
              <div className="row justify-content-end">
                <div className="col-2">
                  <button className="btn" onClick={() => setStep("select")}>
                    <span>بازگشت</span>
                    <i className="fas fa-angle-left mx-2"></i>
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="d-flex flex-column justify-content-between align-items-md-stretch">
                    <div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault1"
                          onClick={() =>
                            setContract({
                              ...contract,
                              contract_type: "everyday",
                            })
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          {`رزرو سانس :‌ ${data && data.data.time} `}
                          {`برای هروز `}
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault2"
                          defaultChecked
                          onClick={() =>
                            setContract({
                              ...contract,
                              contract_type: "onceaweek",
                            })
                          }
                        />

                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault2"
                        >
                          {`رزرو سانس :‌ ${data && data.data.time} `}
                          {`برای  ${Day(data && data.currentDay)}`}
                          {` ها در هفته  `}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <label htmlFor="">تاریخ پایان قرارداد</label>
                  <Calendar
                    onChange={data => {
                      setContract({
                        ...contract,
                        date_end: ConvertDate(
                          `${data.year}/${data.month.number}/${data.day}`
                        ),
                      });
                    }}
                    calendar={persian}
                    // multiple={true}
                    locale={persian_fa}
                  />
                </div>

                <div className="row ">
                  <div className="col">
                    <div>
                      <button
                        className="btn btn-primary"
                        disabled={loadingBtn}
                        onClick={() => {
                          reserveByManager({
                            ...contract,
                            sans_id: data.data.id,
                            day: data.data.day_id,
                            date_start: data.day,
                          });
                        }}
                      >
                        {loadingBtn ? "در حال پردازش" : "ثبت قراردادی"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        case 3:
          return (
            <div>
              <div className="row justify-content-end">
                <div className="col-2">
                  <button className="btn" onClick={() => setStep("select")}>
                    <span>بازگشت</span>
                    <i className="fas fa-angle-left mx-2"></i>
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="d-flex flex-column justify-content-between align-items-md-stretch">
                    <div>
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault2"
                      >
                        {`رزرو سانس :‌ ${data && data.data.time} `}
                        {` در تاریخ : ${ToDateJalali(data && data.day)}`}
                      </label>
                    </div>
                  </div>
                </div>
              </div>{" "}
              <div className="row mt-3">
                <div className="col">
                  <div>
                    <button
                      className="btn btn-primary"
                      disabled={loadingBtn}
                      onClick={() => {
                        reserveByManager({
                          once_reserve: true,
                          sans_id: data.data.id,
                          day: data.data.day_id,
                        });
                      }}
                    >
                      {loadingBtn ? "در حال پردازش" : "رزرو"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        case "select":
          return (
            <div className="d-flex justify-content-between flex-column">
              <button
                className="btn  mb-2 d-flex justify-content-between"
                onClick={() => setStep(1)}
              >
                <span>ویرایش سانس</span>{" "}
                <i className="fas fa-angle-left mx-2"></i>
              </button>
              <button
                className="btn  mb-2 d-flex justify-content-between "
                onClick={() => setStep(3)}
              >
                <span>رزرو سانس</span>
                <i className="fas fa-angle-left mx-2"></i>
              </button>
              <button
                className="btn  mb-2 d-flex justify-content-between"
                onClick={() => setStep(2)}
              >
                <span>ثبت قراردادی</span>
                <i className="fas fa-angle-left mx-2"></i>
              </button>
            </div>
          );
      }
    }
  };
  return renderSteps();
};

export default Index;
const Sans = ({ data, item, day, set, currentDay }) => {
  const { statusHandler, changeStatus, loadingSans } = useTableWeek();

  return (
    <td
      className={`text-center sans-table ${
        statusHandler(data, day)["status"] && "sans-table-hover"
      }`}
      style={statusHandler(data, day) && statusHandler(data, day)["style"]}
    >
      <button
        onClick={() => {
          set(data, item, day, currentDay);
        }}
        disabled={!statusHandler(data, day)["status"]}
        style={{
          backgroundColor: "transparent",
          border: "none",
          padding: "0",
          fontSize: "11px",
        }}
        className="btn text-center p-0"
      >
        {statusHandler(data, day)["status"] == "second_price" && (
          <span
            style={{
              // position: "relative",
              // bottom: "14px",
              color: "rgb(228, 42, 63)",
              // right: "83px",
              fontSize: "8px",
            }}
          >
            تخفیف
          </span>
        )}
        {loadingSans == data.id ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        ) : (
          <div className="d-flex flex-column">
            <span>
              {statusHandler(data, day) && statusHandler(data, day)["text"]}
            </span>
            <span>{GenderRender(data.gender)}</span>
          </div>
        )}
      </button>
    </td>
  );
};
const ShowReserve = ({ data }) => {
  return (
    <div>
      <div>
        <h3>این سانس رزرو شده است</h3>
      </div>
      )
    </div>
  );
};
